import { render, staticRenderFns } from "./LiveLanding.vue?vue&type=template&id=cd519dc0&"
import script from "./LiveLanding.vue?vue&type=script&lang=js&"
export * from "./LiveLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev-002\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd519dc0')) {
      api.createRecord('cd519dc0', component.options)
    } else {
      api.reload('cd519dc0', component.options)
    }
    module.hot.accept("./LiveLanding.vue?vue&type=template&id=cd519dc0&", function () {
      api.rerender('cd519dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/dashboard/components/LiveLanding.vue"
export default component.exports